module.exports = __webpack_public_path__ + "static/media/qzy.791225b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/static/voice/qzy.wav
// module id = R5Cd
// module chunks = 1